<template>
    <v-container grid-list-md>
            <div id="printMe" class="marca">
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th align="left">CPC: {{ data.user.cpc }} Nombre: {{ data.user.user.name }}</th>
                            <th align="right">Factura Numero: {{ data.invoice.id }}</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left">Rif y/o Cedula: {{ data.user.user.nacionality }}{{ data.user.user.number_id }}</th>
                            <th align="right">Fecha de Emision: {{ data.invoice.payment_date }}</th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left"></th>
                            <th align="right">Cond. de pago: </th>
                        </tr>
                    </thead>
                    <thead>
                        <tr>
                            <th align="left"></th>
                            <th align="right">Cajero: caja {{ data.invoice.cash_assignment_id }}</th>
                        </tr>
                    </thead>
                </table>
                <table style="width:100%;">
                    <thead>
                        <tr>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">CODIGO</th>
                            <th align="left" style="border-top: 3px dashed; border-bottom: 3px dashed;">DESCRIPCION</th>
                            <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">COSTO UNIT.</th>
                            <th align="right" style="border-top: 3px dashed; border-bottom: 3px dashed;">TOTAL Bs.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="concepts_old in data.concept_old" :key="concepts_old.id">
                            <td align="left"></td>
                            <td align="left">{{ concepts_old.concepto }}</td>
                            <td align="right">{{ concepts_old.amount }}</td>
                            <td align="right">{{ concepts_old.amount }}</td>
                        </tr>
                        <tr v-for="concept_ruap in data.concept_ruaps" :key="concept_ruap.id">
                            <td align="left">RAP</td>
                            <td align="left">{{ concept_ruap.document_types }}</td>
                            <td align="right">{{ (parseFloat(concept_ruap.monto_document) + parseFloat(concept_ruap.monto_gg)) }}</td>
                            <td align="right">{{ (parseFloat(concept_ruap.monto_document) + parseFloat(concept_ruap.monto_gg)) }}</td>
                        </tr>
                        <!-- <tr v-for="concept_ruap in data.concept_ruaps" :key="(concept_ruap.id + 1000)">
                            <td align="left">GG</td>
                            <td align="left">{{ concept_ruap.document_types }}</td>
                            <td align="right">{{ concept_ruap.monto_gg }}</td>
                            <td align="right">{{ concept_ruap.monto_gg }}</td>
                        </tr> -->
                        <tr v-for="concepts in data.service_payment" :key="concepts.ruap_id">
                            <td align="left">{{ concepts.code }}</td>
                            <td align="left">{{ concepts.name }}</td>
                            <td align="right">{{ concepts.concept_cost_last_amount.amount}}</td>
                            <td align="right">{{ concepts.concept_cost_last_amount.amount * concepts.qty }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" style="border-top: 3px dashed;">FORMA DE PAGO: :  : </td>
                            <td align="right" style="border-top: 3px dashed;">SUB-TOTAL :</td>
                            <td align="right" style="border-top: 3px dashed;">{{ data.invoice.amount}}</td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                            <td align="right">--.-- % IVA :</td>
                            <td align="right">--</td>
                        </tr>
                        <tr>
                            <td colspan="2">SOLO PARA EL USO DEL CONTADOR PUBLICO</td>
                            <td align="right">TOTAL :</td>
                            <td align="right">{{ data.invoice.amount}}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
    </v-container>
</template>

<script>
export default {

    props: {
        data: {
            type: Object,
            required: true
        }
    }
    
}
</script>
<style scoped>
.marca:after {
  content: url('/img/newlogo.png');
  font-size: 15em;
  opacity: 0.1;
  z-index: 1;
 
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 120px;
  right: 0;
  bottom: 0;
  left: 0;
    
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  -ms-pointer-events: none;
  -o-pointer-events: none;
  pointer-events: none;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}

</style>




// WEBPACK FOOTER //
// resources/assets/js/components/factura/FacturaPago.vue